import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Metadata } from 'src/app/entities/invoices';
import { DocType } from 'src/app/entities/various';


export interface ConfigProps{
  configSidebar: ItemSidebar[],
  configTopbar: ItemTopbar[],
  list: {
    listSoggettoEmittente: ItemSelectProps[],
    listTipoSoggetto:ItemSelectProps[],
    listAliquoteIva:ItemSelectProps[],
    listCausalePagamento:ItemSelectProps[],
    listFormatoTrasmissione:ItemSelectProps[],
    listTipoDocumento: ItemSelectProps[],
    listRegimeFiscale: ItemSelectProps[],
    listSocioUnico: ItemSelectProps[],
    listStatoLiquidazione:ItemSelectProps[],
    listRitenuta:ItemSelectProps[],
    listNaturaRitenuta:ItemSelectProps[],
    listEsigibilitaIVA:ItemSelectProps[],
    listCondizioniPagamento:ItemSelectProps[],
    listModalitaPagamento:ItemSelectProps[],
    listTipoCassa:ItemSelectProps[],
    listTipoRigaBeni:ItemSelectProps[],
    listDivisa:ItemSelectProps[],
  },
  tipoNotificaDashboard:ItemSelectProps[],
  visibilityUsers:ItemSelectProps[]
  metadatiFattura: Metadata[]
}

export interface ItemSelectProps{
  label: string,
  val: string,
  tooltip?: string,
  text?: string,
  decimals?: number,
  number?: string
}

export interface ItemSidebar{
  label: string,
  url: string, 
  icon: string, 
  icon_active: string, 
  allow: string[]
}

export interface ItemTopbar{
  label: string,
  url: string, 
  icon: string, 
  icon_active: string, 
  allow: string[],
  position:string,
  classStyle:string
}

@Injectable({
  providedIn: 'root'
})
export class ConfigServiceService {

  private configUrl = "settings/setting.json";
  private conf : ConfigProps | undefined;
  private configDocWf = "settings/doctype_wf.json";
  private confDocType: DocType | undefined;

  constructor(private http: HttpClient) {
  }

  public async getJSON() : Promise<ConfigProps> {
    if (!this.conf){
      this.conf =  await this.http.get(this.configUrl).toPromise().then(
        (data : any) => {
          return data;
        }).catch(() => {});
    }
    return this.conf!;
  }

  public async getDocTypeAttiva(): Promise<DocType> {
    this.confDocType = await this.http.get(this.configDocWf).toPromise().then(
      (res: any) => {
        return res.tipologiadocumentale.fatturaattiva;
      }
    );
    return this.confDocType!;
  }
  public async getWorkflowAttiva(): Promise<DocType> {
    this.confDocType = await this.http.get(this.configDocWf).toPromise().then(
      (res: any) => {
        return res.workflow.fatturazioneattiva;
      }
    );
    return this.confDocType!;
  }
  public async getDocTypePassiva(): Promise<DocType> {
    this.confDocType = await this.http.get(this.configDocWf).toPromise().then(
      (res: any) => {
        return res.tipologiadocumentale.fatturapassiva;
      }
    );
    return this.confDocType!;
  }
  public async getWorkflowPassiva(): Promise<DocType> {
    this.confDocType = await this.http.get(this.configDocWf).toPromise().then(
      (res: any) => {
        return res.workflow.fatturazionepassiva;
      }
    );
    return this.confDocType!;
  }

  public async getDocTypeNso(): Promise<DocType> {
    this.confDocType = await this.http.get(this.configDocWf).toPromise().then(
      (res: any) => {
        return res.tipologiadocumentale.nso;
      }
    );
    return this.confDocType!;
  }
  public async getWorkflowNso(): Promise<DocType> {
    this.confDocType = await this.http.get(this.configDocWf).toPromise().then(
      (res: any) => {
        return res.workflow.nso;
      }
    );
    return this.confDocType!;
  }
}
